import React, { useEffect } from 'react';

import AgentPage from '../hocs/AgentPage';
import AgentHeader from '../AgentHeader';

export default AgentPage(function AgentContractPlans (props) {
  const { agent, setBreadNavValues, canEditMembers, } = props;
  useEffect(() => {
    setBreadNavValues({ agent });
  }, [agent]);

  return (
    <div>
      <div className="agent-contract-plans container py-5 position-relative">
        <AgentHeader activeTab="contractPlans" agent={agent} canEditMembers={canEditMembers} />
        <div className="bg-white p-4">
          <div className="row">
            <div className="col-12">
              <div className="card p-2" style={{ whiteSpace: 'pre-line' }}>
                {agent.agentContractPlanText}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
